{
  "main": {
    "title": "Task Documentation",
    "nazaj": "Back"
  },
  "stevilcni": {
    "vsiD": "All documents",
    "vsiN1": "All",
    "vsiN2": "NOT",
    "vsiN3": "-approved documents",
    "vsiP": "All approved tasks",
    "vsiZ": "All rejected tasks"
  },
  "potrjevanje": {
    "odobri": "Approve",
    "zavrni": "Reject",
    "naloge": "tasks",
    "datum": "Date",
    "poslal": "Sent by",
    "odobreni": "approved",
    "nalogi": "tasks",
    "zavrnjeni": "rejected"
  },
  "table": {
    "nalogiTitle": "Task documents"
  },
  "modal": {
    "opomba": "Note: Why I am rejecting the document!"
  },
  "buttons": {
    "stevilcni": "Numerical overview",
    "zapriPregled": "Close overview",
    "zavrniDokument": "Reject document",
    "potrdiDokument": "Approve document"
  }
}